import { httpClient } from "./httpClient";


const allPayTypes = () => {
  return httpClient.get("paytypes");
};

const addPaytypes = (formData) => {
  return httpClient.post(`paytypes`, formData);
};

const updatePaytypes = (formData) => {
  return httpClient.put(`paytypes`, formData);
};

const updatePayrollSetting = (idPayrollSetting, formData) => {
  return httpClient.put(`payroll-setting/${idPayrollSetting}`, formData);
};

const getPayrollSetting = (query) => {
  return httpClient.get("payroll-setting", { params: query });
};

const updatePayrollDateCustom = (formData) => {
  return httpClient.put(`payroll-setting/date-custom`, formData);
};

export default {
  allPayTypes,
  addPaytypes,
  updatePaytypes,
  updatePayrollSetting,
  getPayrollSetting,
  updatePayrollDateCustom
};
